"use client";

import React from "react";

/**
 * Common RandomizedMapMarkers component
 * Uses deterministic positioning to prevent hydration mismatches
 * between server and client rendering
 */
export function RandomizedMapMarkers() {
	const markers = React.useMemo(() => {
		// Use deterministic positioning to prevent hydration mismatches
		const positions = [
			{ top: 25, left: 30, size: "small" },
			{ top: 45, left: 70, size: "large" },
			{ top: 60, left: 20, size: "small" },
			{ top: 35, left: 80, size: "small" },
			{ top: 75, left: 45, size: "large" },
			{ top: 20, left: 60, size: "small" },
			{ top: 55, left: 15, size: "small" },
			{ top: 40, left: 50, size: "small" },
		];

		return positions.map((pos, i) => ({
			id: i,
			...pos,
		}));
	}, []);

	return (
		<>
			{markers.map(marker => (
				<div
					key={marker.id}
					className={`absolute marker bg-primary-500 rounded-full shadow-lg animate-pulse ${
						marker.size === "large" ? "w-3 h-3" : "w-2 h-2"
					}`}
					style={{
						top: `${marker.top}%`,
						left: `${marker.left}%`,
					}}
				/>
			))}
		</>
	);
}
